
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class DangerButton extends Vue {
  @Prop({
    default: "auto",
  })
  width!: string | number;

  @Prop({
    default: "30px",
  })
  height!: string | number;

  @Prop({
    default: false,
  })
  disabled!: boolean;

  @Prop({
    default: false,
  })
  loading!: boolean;

  @Prop({
    default: null,
  })
  icon!: string | null;
}
